import angular from 'angular'

import { offEvent, onEventPassive } from './on-event'

angular
  .module('ggs.utils')
  .factory('WaitOnLoad', WaitOnLoadProvider)

function WaitOnLoadProvider($q) {
  return function WaitOnLoad() {
    return $q((resolve) => {
      if (document.readyState === 'complete') {
        resolve()
      } else {
        onEventPassive(window, 'load', loadHandler)
      }

      function loadHandler() {
        offEvent(window, 'load', loadHandler)
        resolve()
      }
    })
  }
}
